import React from 'react';
import PropTypes from 'prop-types';
import { FieldContainer } from './CustomRadioField.styles';

const CustomRadioFieldSet = ({ name, value, disabled, label, radioButtons, selectedValue, onChange, noDefault }) => (
  <FieldContainer>
    <input
      type="radio"
      checked={(!noDefault && !selectedValue && value === radioButtons[0].value) || value === selectedValue}
      name={name}
      id={`${name}-${value}`}
      value={value}
      disabled={disabled}
      onChange={onChange}
    />
    <label htmlFor={`${name}-${value}`}>{label}</label>
  </FieldContainer>
);

CustomRadioFieldSet.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  selectedValue: PropTypes.string,
  onChange: PropTypes.func,
  noDefault: PropTypes.bool,
  radioButtons: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.node.isRequired,
      value: PropTypes.string.isRequired,
      disabled: PropTypes.bool
    })
  )
};

export default CustomRadioFieldSet;
